
import uuid from "uuid/v4";

export function addCategoryNode(entity, expanded) {
	return {
		"id" : uuid(),
		"entity": entity,
		"expanded": expanded,
		"children": []
	};
}

export function addItemNode(entity) {
	return {
		"id": uuid(),
		"entity": entity
	};
}

export function addCategoryEntity(entityId, label, visible) {
	return {
		"entityId": entityId,
		"id": "",
		"type": "category",
		"label": label,
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"visible": visible
	};
}

export function addListEntity(entityId, label) {
	return {
		"entityId": entityId,
		"id": "",
		"type": "list",
		"label": label,
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"defaultView": "checklistView",
		"color": "black",
		"suppressPrint": false,
		"visible": true,
		"enabled": true,
		"ignoreCompletion": false,
		"groupNames": [],
		"filterTags": []
	};
}

export function addSectionEntity(entityId, label) {
	return {
		"entityId": entityId,
		"id": "",
		"type": "section",
		"label": label,
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"color": "#ffffff",
		"backgroundColor": "#888888",
		"borderColor": "#888888",
		"iconColor": "#ffffff",
		"suppressPrint": false,
		"visible": true,
		"enabled": true,
		"ignoreCompletion": false,
		"groupNames": [],
		"filterTags": []
	};
}

export function addItemEntity(entityId, label, label2, labelOnly, mandatory, comments, type) {
	// Need to support types
	return {
		"entityId": entityId,
		"id": "",
		"type": type?type:"item",
		"label": label,
		"label1AlexaPlain": "",
		"label1AlexaRich": "",
		"label1Audio": "",
		"label1Ssml": "",
		"label1Print": "",
		"backgroundColor": "transparent",
		"color": "black",
		"label2": label2,
		"label2AlexaPlain": "",
		"label2AlexaRich": "",
		"label2Audio": "",
		"label2Ssml": "",
		"label2Print": "",
		"label2Color": "black",
		"labelOnly": labelOnly,
		"labelOnlyBackgroundColor": "#FFF8C6",
		"linkOnCheck": false,
		"linkId": "",
		"linkActionType": "goto",
		"visible": true,
		"enabled": true,
		"mandatory": mandatory,
		"comments": comments,
		"commentsInline": false,
		"commentsAuthor": "",
		"commentsAudio": "",
		"commentsSsml": "",
		"commentsPrint": "",
		"commentsTemplate": "",
		"commentsDataPath": "",
		"backgroundImage": "",
		"video": "",
		"image": "",
		"audio": "",
		"pdf": "",
		"suppressPrint": false,
		/*"suppressAudio": false,*/
		"startTimer": false,
		"stopTimer": false,
		"ignoreCompletion": false,
		"groupNames": [],
		"filterTags": []
	};
}
/**
 * HCS 02/08/2019: Changed this so that default color is not set in style, this way the global stylesheet can drive font colors.
 */
export function getLabel1Color(item, defaultColor=null) {
	let label1Color = defaultColor;
	if (item.hasOwnProperty("color") && item.color !== "" && item.color !== "black") {
		label1Color = item.color;
	}

	return label1Color;
}

export function getLabel2Color(item, defaultColor = null) {
	let label2Color = defaultColor;
	if (item.hasOwnProperty("label2Color") && item.label2Color !== "" && item.label2Color !== "black") {
		label2Color = item.label2Color;
	}

	return label2Color;
}

